import React from 'react';

import { Skeleton } from '@material-ui/lab';
import { isNil } from 'lodash';

import RightPanel from 'pages/LiveClassroom/components/RightPanel/index';
import StudentsOverview from 'pages/LiveClassroom/components/StudentsOverview/index';

import styles from './style.module.scss';

const ClassroomDashboard = ({ students, insightsStatus }) => {
  const checkInWith = students
    ?.filter((s) => s.status === 'need_help')
    .map((s) => s.name);
  const celebrationCount = students?.filter(
    (s) => s.status === 'completed'
  ).length;

  return (
    <>
      {isNil(students) ? (
        <div className={styles.dashboard}>
          <div className={styles.studentsSkeleton}>
            <Skeleton variant="rect" width={100} height={100} />
            <Skeleton variant="rect" width={100} height={100} />
            <Skeleton variant="rect" width={100} height={100} />
            <Skeleton variant="rect" width={100} height={100} />
            <Skeleton variant="rect" width={100} height={100} />
          </div>

          <Skeleton variant="rect" width={'100%'} height={300} />
        </div>
      ) : (
        <div className={styles.dashboard}>
          <StudentsOverview students={students} />
          <RightPanel
            checkInWith={checkInWith}
            celebrationCount={celebrationCount}
            insightsStatus={insightsStatus}
          />
        </div>
      )}
    </>
  );
};

export default ClassroomDashboard;
